export default __webpack_public_path__ + "static/media/BeatBoxResponsiveSmall.6f359e49.png";